import styled from 'styled-components';

export const SiteLinkDiv = styled.div`
  padding: 5px;
`;

export const SiteLink = styled.a`
  height: 14px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
  text-align: center;
  font-size: 14px;
  border-bottom: 1px solid #20907F;
  text-align: right;
  padding-right: 5px;
  color: #20907F !important;
  cursor: pointer;
`;

export const SiteLinkDisabled = styled(SiteLink)`
    cursor: default;
    border-bottom: none;
    color: #5C5756 !important;
`;

